import { useMemo } from 'react';
import { ReportingILSStrategyBuilder } from 'customer-data-filters-ui/public/strategies';
import { hasObjectTypeId } from '../../../utils/source-utils';
import DSFieldRecord from 'customer-data-filters/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import { toPropertyBasicType } from '../../../../dataset/type-utils';
export const useDatasetFilterStrategy = ({
  source,
  shouldUseLegacyDateFilter = false
}) => {
  const datasetFields = source.getIn(['dataset', 'fields']);
  const dataType = hasObjectTypeId(source) ? source.objectTypeId : source.dataSourceId;
  const strategy = useMemo(() => {
    // Convert to correct DSFieldRecordType
    const updatedProps = datasetFields.map(field => {
      return DSFieldRecord({
        name: field.name,
        label: field.label,
        type: toPropertyBasicType(field.type)
      });
    });
    return ReportingILSStrategyBuilder({
      getField: (_, id, originalField) => {
        return updatedProps.get(id) || originalField;
      },
      getFields: () => updatedProps,
      getFilterFamilyName: () => dataType,
      getFilterFamilyObjectName: () => dataType,
      reportingFilterContext: 'snowflake_expression',
      supportsLegacyILSDateTimeFilters: shouldUseLegacyDateFilter,
      isIncludeObjectsWithNoValueSetCheckboxEnabled: true
    });
  }, [dataType, datasetFields, shouldUseLegacyDateFilter]);
  return strategy;
};